export const background = `
  p-1 rounded-full flex items-center justify-center transition-colors

  bg-[var(--background)]
  group-hover/color-icon:bg-[var(--fill)]
  group-data-[is-active=true]/color-icon:bg-[var(--fill)]

  sm:p-1.5
`;
export const icon = `
  w-3.5 h-3.5 transition-colors

  fill-[var(--fill)]
  group-hover/color-icon:fill-base-white
  group-data-[is-active=true]/color-icon:fill-base-white
`;
